import SalesDashboard from '@/views/SalesDashboard.vue'
import { useAuthStore } from '../../stores/auth'

// Helper function locally if needed or import
const hasAnyPermission = (permissions) => {
    const authStore = useAuthStore();
    return permissions.some(permission => authStore.hasPermission(permission));
};

export const dashboardRoutes = [
    {
        path: 'dashboard',
        name: 'dashboard',
        component: () => import('../../views/Dashboard.vue'),
        meta: {
            requiresAuth: true,
            checkPermissions: (to, from, next) => {
                const requiredPermissions = [
                    'dashboard.view_quick_actions',
                    'dashboard.view_alerts',
                    'dashboard.view_stats'
                ];
                if (hasAnyPermission(requiredPermissions)) {
                    next();
                } else {
                    next('/unauthorized');
                }
            }
        }
    },
    {
        path: 'sales-dashboard',
        name: 'sales-dashboard',
        component: SalesDashboard,
        meta: {
            requiresAuth: true,
            title: 'Sales Dashboard',
            permissions: ['salesdashboard.view'],
            checkPermissions: (to, from, next) => {
                const authStore = useAuthStore();
                const requiredPermissions = ['salesdashboard.view'];
                if (requiredPermissions.some(permission => authStore.hasPermission(permission))) {
                    next();
                } else {
                    next('/forbidden');
                }
            },
            breadcrumb: [
                { name: 'Sales Dashboard' }
            ]
        }
    }
];
